"use client";

import { ComplexBuyButton } from "@/components/ecommerce/complex-buy-button";
import { roundUpSecondsToMinutes } from "@/service/date/minute";
import { renderMoney } from "@/service/ecommerce/currency";
import { resolvePluralsMinutes } from "@/service/text/plurals";

export const BuyCourseCTA = ({ course }: { course: CourseVM }) => {
  // Nieuprawniony user na darmowym kursie Rx nie może odebrać — komunikat pokazuje się zamiast zwiastuna.
  if (!course.access.granted) {
    return null;
  }

  const { product, duration, isFreebie } = course;
  const { price, promotionPrice, omnibusPrice, details } = product ?? {};

  const realDuration = resolvePluralsMinutes(roundUpSecondsToMinutes(duration));

  const isFree = parseFloat(price ?? "0") === 0;

  return (
    <div className="bg-remedium-blue/5 flex w-full max-w-[500px] flex-col gap-6 rounded-xl p-4">
      {!isFree && (
        <div className="flex flex-col gap-2">
          {price && price !== promotionPrice && (
            <p className="text-sm text-red-500 line-through">
              {renderMoney(price)}
            </p>
          )}
          {promotionPrice && (
            <p className="text-2xl font-semibold text-zinc-950">
              {renderMoney(promotionPrice)}
            </p>
          )}
        </div>
      )}
      <div className="flex flex-col gap-2">
        {details &&
          details.map(({ name }) => (
            <div key={name} className="text-sm">
              {name.startsWith("Dostęp do kursu przez") ? (
                <p className="text-sm">
                  Dostęp do kursu przez:{" "}
                  <strong className="font-semibold">
                    {name.split("Dostęp do kursu przez")[1]}
                  </strong>
                </p>
              ) : (
                <p className="text-sm">{name}</p>
              )}
            </div>
          ))}
        <p className="text-sm">
          Czas trwania:{" "}
          <strong className="font-semibold">{realDuration}</strong>
        </p>
        {!isFree && omnibusPrice && (
          <p className="text-muted-foreground text-[10px]">
            Najniższa cena z 30 dni przed obniżką {renderMoney(omnibusPrice)}
          </p>
        )}
      </div>
      <ComplexBuyButton
        product={course.product ?? undefined}
        isOwned={false}
        exclusiveAccess={course.exclusiveAccess}
        publishedAt={course.publishedAt}
        slug={course.slug}
        id={String(course.id)}
        title={course.title}
        variant={"blue"}
        isFreebie={isFreebie}
      />
    </div>
  );
};
